// extracted by mini-css-extract-plugin
module.exports = {"phone-container":"PhoneInput_phone-container__1ANK5","phone-input":"PhoneInput_phone-input__T_Z9A","error":"PhoneInput_error__QtWxk"};